import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPage } from "@/lib/analytics";

export default function AnalyticsTracker() {
  const loc = useLocation();
  useEffect(() => { trackPage(); }, [loc.pathname]);
  return null;
}
